/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiJobSubmitResponseItem,
    ApiJobSubmitResponseItemFromJSON,
    ApiJobSubmitResponseItemFromJSONTyped,
    ApiJobSubmitResponseItemToJSON,
} from './ApiJobSubmitResponseItem';

/**
 * 
 * @export
 * @interface ApiJobSubmitResponse
 */
export interface ApiJobSubmitResponse {
    /**
     * 
     * @type {Array<ApiJobSubmitResponseItem>}
     * @memberof ApiJobSubmitResponse
     */
    jobResponseItems?: Array<ApiJobSubmitResponseItem>;
}

export function ApiJobSubmitResponseFromJSON(json: any): ApiJobSubmitResponse {
    return ApiJobSubmitResponseFromJSONTyped(json, false);
}

export function ApiJobSubmitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiJobSubmitResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobResponseItems': !exists(json, 'jobResponseItems') ? undefined : ((json['jobResponseItems'] as Array<any>).map(ApiJobSubmitResponseItemFromJSON)),
    };
}

export function ApiJobSubmitResponseToJSON(value?: ApiJobSubmitResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jobResponseItems': value.jobResponseItems === undefined ? undefined : ((value.jobResponseItems as Array<any>).map(ApiJobSubmitResponseItemToJSON)),
    };
}

